import React, { useEffect } from 'react';
import Footer from '../../../../../core-components/Footer/footer';
import SeoSearchHeader from '../../SearchPage/components/ModifySearchHeader/ModifySearchHeaderUI';
import MultiCityPackages from './Components/MultiCityPackages'
import WhyChooseWithUs from './Components/WhyChooseWithUs';
import CharDhamItinery from './Components/CharDhamItineray';
import ThingsToKeepInMind from './Components/ThingsToKeepInMind';
import CharDhamInfo from './Components/CharDhamInfo';
import styled from 'styled-components';
import InboundCallWidget from '../containers/InboundCallWidget/InboundCallWidget';
import { useDispatch, useSelector } from 'react-redux';
import { gcRouteSEOScreen, getLoadedComponent, pushCtaOmniEvents } from '../../../config/omni';
import { CABS_CHAR_DHAM_ROUTE, CHAR_DHAM_PAGE, CharDhamPageComp, MOB_CABS_CHAR_DHAM } from '../../../utils/util-constants';
import { pageView } from '../../../config/ga';
import { faqSelector, seoCharDhamSelector } from '../redux/selector';
import SeoPageHeader from '../containers/SeoPageHeader/SeoPageHeaderUI'
import { CTA_TYPE } from '../../../utils/omni-utils';
import Faq from '../../../../stories/components/cars/SeoPage/Faq/FaqUI';
import { CHAR_DHAM_DATA, CHAR_DHAM_IMAGES } from '../../../config/constants';

const PageContainer = styled.div`
    margin-bottom: 100px;
    background-color: #eef4fd;
`;

const HeaderContainer = styled.div`
    width: 100%;
    height: 300px;
    background-image: url(${CHAR_DHAM_IMAGES.BG_IMAGE});
    padding-top: 0;
    background-repeat: no-repeat;
    position:relative;
    background-size: 100% 100%;
`;

export const HeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const HeaderTitle = styled.p`
    font-size: 36px;
    font-weight: 700;
    color: black;
    margin-top: 32px;
`;

export const HeaderSubtitle = styled.p`
    font-size: 28px;
    margin-bottom: 24px;
`;

export const ContentContainer = styled.div`
    padding-left: 200px;
    padding-right: 200px;

    @media (max-width: 1477px) {
      padding-left: 50px;
      padding-right: 50px;
    }
`;

const McHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const DhamHeader = styled.div`
      font-size: 22px;
      padding: 16px 0px;
`;
const DhamHeaderText = styled.span`
    font-size: 24px;
    font-weight: bold;
    color: #717171;
`;

const Header = styled.div`
max-width: 1200px;
margin-top:20px;
`;

const FaqContainer = styled.div`
    margin-left: 200px;
    margin-right: 200px;

    @media (max-width: 1477px) {
      margin-left: 50px;
      margin-right: 50px;
    }
`;

const CharDhamPage = () => {
  const dispatch = useDispatch();
  const charDhamInfo = useSelector(seoCharDhamSelector);
  const faqs = useSelector(faqSelector);
  const { packages, thingToKeepInMind, itineraryInfo, dhamInfo, whyChooseUs,assistanceData } = charDhamInfo;

  const trackEvent = (eventName) => {
    pushCtaOmniEvents(`${MOB_CABS_CHAR_DHAM}_${eventName}`, CTA_TYPE.BUTTON, CHAR_DHAM_PAGE , CABS_CHAR_DHAM_ROUTE)
  }

  useEffect(() => {
    getLoadedComponent(CharDhamPageComp);
    try {
      dispatch(pageView(gcRouteSEOScreen));
    } catch (e) {
      console.log("error", e);
    }
  }, []);

  return (
    <>
      <PageContainer>
        <HeaderContainer>
          <HeaderContent>
            <HeaderTitle>{CHAR_DHAM_DATA.CHAR_DHAM_HEADER}</HeaderTitle>
            <HeaderSubtitle>
              {CHAR_DHAM_DATA.CHAR_DHAM_SUBHEADER}
            </HeaderSubtitle>
            <SeoSearchHeader
              isSeo={true}
              defaultShowWidget=""
              charDham={true}
            />
          </HeaderContent>
        </HeaderContainer>
        <ContentContainer>
          <Header>
            <SeoPageHeader charDham={true} />
          </Header>
          <McHeader>
            <DhamHeader>
              <DhamHeaderText>Explore Trip Prices from </DhamHeaderText>
              <span
                style={{
                  textDecoration: "underline",
                  fontSize: 24,
                  fontWeight: "bold",
                }}
              >
                New Delhi
              </span>
            </DhamHeader>
            <InboundCallWidget
              inboundCallText={"Talk to agent (24x7)"}
              inboundCallNumber={"0124 - 4781861"}
              isForm={false}
            />
          </McHeader>
          <MultiCityPackages packages={packages} trackEvent={trackEvent}/>
        </ContentContainer>
        <WhyChooseWithUs whyChooseUs={whyChooseUs} data={assistanceData} trackEvent={trackEvent}/>
        <CharDhamItinery itineryList={itineraryInfo} />
        <ThingsToKeepInMind instructionList={thingToKeepInMind} />
        <CharDhamInfo charDhamInfo={dhamInfo} trackEvent={trackEvent}/>
        <FaqContainer>
        <Faq faqHeading={faqs?.faq_heading} faqData={faqs?.faq_content} />
        </FaqContainer>
      </PageContainer>
      <Footer />
    </>
  );
};

export default CharDhamPage;
